type ZodGlobal = typeof globalThis & {
  __zod_globalConfig?: {
    jitless?: boolean;
  };
};

const zodGlobal = globalThis as ZodGlobal;

// Zod v4 probes `new Function("")` for its JIT fast path, which creates
// report-only CSP noise under strict script-src policies. Pre-populate the
// global config before Zod is imported transitively by the AI SDK so Zod skips
// the probe. See https://github.com/colinhacks/zod/issues/4461 and
// https://github.com/colinhacks/zod/pull/5889.
zodGlobal.__zod_globalConfig = {
  ...zodGlobal.__zod_globalConfig,
  jitless: true,
};
